import { Grid, Typography } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { SettingsIcon } from "../../shared/icons";
import { useHistory } from "../../shared/hooks/useHistory";

interface HeaderScreenProps {
  onBack: () => void;
  title: string;
  hideSettingsIcon?: boolean;
}

export const HeaderScreen = (props: HeaderScreenProps) => {
  const { title, onBack, hideSettingsIcon } = props;
  const history = useHistory();

  return (
    <Grid item sm={12} xs={12} data-testid="header-screen">
      <Typography
        className="header"
        variant="button"
        onClick={onBack}
        data-testid="title"
      >
        <span>
          <ArrowBackIosIcon data-testid="arrow-icon" /> {title}
        </span>
        {!hideSettingsIcon && (
          <SettingsIcon
            onClick={() => history.push("/participant/settings")}
            className="settings"
          />
        )}
      </Typography>
    </Grid>
  );
};
